// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"a9a3a2e8","498":"89a940eb","703":"ff2fb421"}[chunkId] + ".chunk.js";
};